import { STORAGE_KEYS } from 'constants/common'
import BaseApi from './base'

class User extends BaseApi {
  logoutUser = () =>
    this.client.post(
      'logout',
      {},
      {
        headers: {
          RefreshToken: `Bearer ${localStorage.getItem(STORAGE_KEYS.refreshToken)}`
        }
      }
    )

  refreshToken = () =>
    this.client.post(
      'refresh-token',
      {},
      {
        headers: {
          RefreshToken: `Bearer ${localStorage.getItem(STORAGE_KEYS.refreshToken)}`
        }
      }
    )

  loginUser = (data) => this.client.post('/login', data)

  fetchProfile = () => this.client.get('me')

  getUsers = (query) => this.client.get(`admin/users?${query}`)

  addUser = (data) => this.client.post('admin/users', data)

  updateUser = (id, data) => this.client.patch(`admin/users/${id}`, data)

  deleteUser = (id) => this.client.delete(`admin/users/${id}`)

  getUserDetail = (id) => this.client.get(`admin/users/${id}`)

  updateStatusUser = (data) =>
    this.client.put(`admin/users/change-status`, data)

  updatePasswordUser = (id, data) =>
    this.client.put(`admin/users/change-password/${id}`, data)

  updateMyProfile = (data) => this.client.patch('user/my-profile', data)

  updateMyPassword = (data) => this.client.post('change-password', data)
}

export default new User()
